import type { VenueDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getVenueDetails(venueId: string): Promise<VenueDetailed> {
  return requestApiJsonOrThrow<VenueDetailed>(`admin/venues/${venueId}`)
}

export const venueDetailsQuery = (venueId: string) => ({
  queryKey: ['venue', venueId],
  queryFn: () => getVenueDetails(venueId),
})
